const routes = [
  {
    //默认路由
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    component: () => import("../paegs/youzhi/index.vue"),
    meta: {
      title: "有职offer",
      auth: false,
      keepAlive: true,
    },
  },
  {
    path: "/services",
    component: () => import("../views/Services.vue"),
    meta: {
      title: "有职offer",
      auth: false,
      keepAlive: true,
    },
  },
  {
    path: "/contact",
    component: () => import("../views/Contact.vue"),
    meta: {
      title: "有职offer",
      auth: false,
      keepAlive: true,
    },
  },
  {
    path: "/detail",
    component: () => import("../paegs/detail/detail.vue"),
    meta: {
      title: "有职offer",
      auth: false,
    },
  },
  {
    path: "/miniApp",
    component: () => import("../paegs/miniapp/miniapp.vue"),
    meta: {
      title: "有职offer",
      auth: false,
    },
  },
];
export default routes;
